import React, { type JSX } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import Tooltip from "../Tooltip";

/** Circular plus icon (blue circle with white plus) */
export function CirclePlusIcon({ className = "" }: { className?: string }): JSX.Element {
  return (
    <div
      className={`flex items-center justify-center rounded-full ${className}`}
      style={{ backgroundColor: "#234E81" }}
    >
      <PlusIcon className="h-3.5 w-3.5 text-white" strokeWidth={2.5} />
    </div>
  );
}

/**
 * Ctrl+click or Cmd+click opens a real new tab (default browser behaviour for
 * an anchor); a regular click is intercepted and handled in-app.
 */
export function newTabAwareClick(
  event: React.MouseEvent<HTMLAnchorElement>,
  action?: () => void
): void {
  if (event.ctrlKey || event.metaKey) {
    return;
  }
  event.preventDefault();
  action && action();
}

export default function NewChatLink({
  isCollapsed,
  onStartProject,
}: {
  isCollapsed: boolean;
  onStartProject?: () => void;
}): JSX.Element {
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>): void =>
    newTabAwareClick(e, onStartProject);

  if (isCollapsed) {
    return (
      <Tooltip content="New chat">
        <a
          href={window.location.origin}
          onClick={onClick}
          className="w-full aspect-square flex items-center justify-center p-2 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200"
          aria-label="New Chat"
        >
          <CirclePlusIcon className="h-6 w-6" />
        </a>
      </Tooltip>
    );
  }

  return (
    <a
      href={window.location.origin}
      onClick={onClick}
      className="w-full flex items-center gap-3 px-3 py-2 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200"
    >
      <CirclePlusIcon className="h-6 w-6" />
      <span className="text-sm font-medium" style={{ color: "#234E81" }}>
        New chat
      </span>
    </a>
  );
}
